module.exports = __webpack_public_path__ + "img/logo-tagline.0868653a.svg";